import React from 'react'

interface IconProps {
  size?: number
  color?: string
  strokeWidth?: number
  className?: string
  onClick?: React.MouseEventHandler<SVGSVGElement>
  tooltip?: string
  style?: React.CSSProperties
}

export const PlusIcon: React.FC<IconProps> = ({
  size = 24,
  color = 'currentColor',
  strokeWidth = 2,
  className = '',
  onClick,
  tooltip,
  style,
}) => {
  return (
    <svg
      style={{ cursor: 'pointer', ...style }}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      onClick={onClick}
    >
      {tooltip && <title>{tooltip}</title>}
      <path d="M12 5V19" />
      <path d="M5 12H19" />
    </svg>
  )
}

export default PlusIcon
